import FolderCopyOutlinedIcon from '@mui/icons-material/FolderCopyOutlined';

// ==============================|| UTILITIES MENU ITEMS ||============================== //

const staffDocuments = {
    id: 'staff-docs',
    title: 'Efetivo',
    type: 'group',
    children: [
        {
            id: 'docs',
            title: 'Documentos',
            type: 'collapse',
            icon: FolderCopyOutlinedIcon,

            children: [
                {
                    id: 'docs',
                    title: 'Habilitação',
                    type: 'item',
                    url: 'documentos-efetivos',
                    isChildren: true
                },
                {
                    id: 'docs-mensais-efetivos',
                    title: 'Mensais',
                    type: 'item',
                    url: 'documentos-mensais-efetivos',
                    isChildren: true
                }
            ]
        }
    ]
};

export default staffDocuments;
